import React, { memo, useCallback } from "react";

import Check from "@src/assets/svg/components/Check";
import Copy from "@src/assets/svg/components/Copy";

import styles from "./ChatMessage.module.css";

interface CopyButtonProps {
  content: string;
  messageId: string;
  isCopied: boolean;
  onCopy: (content: string, messageId: string) => void;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  content,
  messageId,
  isCopied,
  onCopy,
}) => {
  const handleClick = useCallback(() => {
    onCopy(content, messageId);
  }, [content, messageId, onCopy]);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onCopy(content, messageId);
      }
    },
    [content, messageId, onCopy]
  );

  const ariaLabel = isCopied ? "Copied to clipboard" : "Copy to clipboard";

  return (
    <div className={styles.copyButtonWrapper}>
      <div
        className={styles.copyButton}
        onClick={handleClick}
        aria-label={ariaLabel}
        role="button"
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        {isCopied ? <Check /> : <Copy />}
      </div>
    </div>
  );
};

export default memo(CopyButton);
